import Layout from '@/layout'

const memberManagerRoutes = [{
    path: '/memberManager',
    component: Layout,
    meta: {title: '会员管理', icon: 'peoples'},
    children: [{
        path: 'memberManager',
        name: 'memberManager',
        component: () => import ('@/views/memberManager/memberInfo'),
        meta: {title: '会员信息', icon: 'people'}
    }, {
        path: 'memberLevelConfig',
        name: 'memberLevelConfig',
        component: () => import ('@/views/memberManager/memberLevelConfig'),
        meta: {title: '会员等级配置', icon: 'money'}
    }, {
        path: 'rightsConfig',
        name: 'rightsConfig',
        component: () => import ('@/views/memberManager/rightsConfig'),
        meta: {title: '权益配置', icon: 'form'}
    }, {
        path: 'integralRule',
        name: 'integralRule',
        component: () => import ('@/views/memberManager/integralRule'),
        meta: {title: '积分规则', icon: 'tree-table'}
    }]
},]

export default memberManagerRoutes
